import * as React from 'react';
import Credits from '../components/Credits';
import Col from '../components/Grid/Col';
import Row from '../components/Grid/Row';
import LogoFull from '../components/LogoFull';

const Footer = () => (
  <footer>
    <div className="container-xl py-16">
      <Row lg={2} className="items-end">
        <Col>
          <LogoFull className="h-14 max-w-full" />
          <span className="sr-only">Музей Миколи Помоненка</span>
        </Col>
        <Col className="flex-shrink space-y-2 lg:text-right mt-12 lg:mt-0">
          <Credits />
        </Col>
      </Row>
    </div>
  </footer>
);

export default Footer;
